import { LegacyPagePaths } from "App/routes/paths";

import { RecentActivityRerouter } from "./RecentActivityRoutingPage";

import type { RegalRouteObject } from "App/routes/types";

export const rerouteRecentActivityRoute: RegalRouteObject = {
    path: LegacyPagePaths.recentActivity,
    element: <RecentActivityRerouter />,
    children: [
        {
            path: "*",
            element: <RecentActivityRerouter />,
        },
    ],
};
